<template>
  <div class="flex col align center">
    <navbar active='1'></navbar>
    <div class="flex col align center">
      <img src="@/assets/page1.png" class="firstimg"/>
      <hr />
      <img src="@/assets/page2.png" />
      <hr />
      <img src="@/assets/page3.png" />
      <hr />
      <img src="@/assets/page4.png" />
      <hr />
      <img src="@/assets/page5.png" />
      <hr />
      <img src="@/assets/page6.png" />
      <hr />
      <img src="@/assets/page7.png" />
      <hr />
      <img src="@/assets/page8.png" />
      <hr />
      <img src="@/assets/page9.png" />
      <hr />
      <img src="@/assets/page10.png" />
      <hr />
      <img src="@/assets/page11.png" />
      <hr />
      <img src="@/assets/page12.png" />
      <hr />
      <img src="@/assets/page13.png" />
    </div>
  </div>
</template>

<script>
import Navbar from '../components/Nav.vue'

export default {
  name: 'portfolio',
  components: {
    navbar: Navbar
  }
}
</script>

<style scoped>
img{
  width: 1100px;
  height: auto;
}
.firstimg{
  margin-top: 0px;
}
@media screen and (max-width: 1200px){
  img{
    margin: 4px;
    width: 95%;
  }
}
</style>
